import { RefObject } from 'react';
import Draggable, { DraggableData } from 'react-draggable';
import { Box } from '@chakra-ui/react';
import { PanelLineGrabIcon } from 'ui/icons/Icons';
import { PointB } from 'schemas/pointSchema';

const size = 100;

const PanelLineDraggablePoint = ({
  nodeRef,
  initPos,
  scaleRatio,
  onChange,
  onChangeStart,
  onChangeEnd,
  color,
  opacity,
}: {
  nodeRef: RefObject<HTMLDivElement>;
  initPos: PointB;
  scaleRatio: number;
  color: string;
  opacity?: number;
  onChange?: (dragData: DraggableData) => void;
  onChangeStart?: (dragData: DraggableData) => void;
  onChangeEnd?: (dragData: DraggableData) => void;
}) => (
  <Draggable
    nodeRef={nodeRef}
    defaultPosition={{
      x: initPos.x,
      y: initPos.y,
    }}
    scale={scaleRatio}
    onDrag={(e, data) => {
      onChange?.(data);
    }}
    onStart={(e, data) => {
      onChangeStart?.(data);
    }}
    onStop={(e, data) => {
      onChangeEnd?.(data);
    }}
  >
    <div
      id="centerWrapper"
      style={{
        color: 'blue',
        transform: `translate(-50%, -50%)`,
        opacity: opacity || 1,
      }}
      ref={nodeRef}
    >
      <Box
        style={{
          position: 'absolute',
          width: size,
          height: size,
          // backgroundColor: 'cyan',
          transform: `translate(-50%, -50%)`,
          // borderRadius: '25px',
          cursor: 'grab',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        _hover={{
          backgroundColor: 'primaryColor_opacity',
          // opacity: '0.2',
          borderRadius: size / 2,
        }}
      >
        <PanelLineGrabIcon color={color} size={size / 2} />
      </Box>
    </div>
  </Draggable>
);

export default PanelLineDraggablePoint;
